module.exports = __webpack_public_path__ + "img/floppy-disks.7d4ac0fd.svg";